import { render, staticRenderFns } from "./MyStaffKPIForm.vue?vue&type=template&id=177a615a&scoped=true"
import script from "./MyStaffKPIForm.vue?vue&type=script&lang=js"
export * from "./MyStaffKPIForm.vue?vue&type=script&lang=js"
import style0 from "./MyStaffKPIForm.vue?vue&type=style&index=0&id=177a615a&prod&lang=css"
import style1 from "./MyStaffKPIForm.vue?vue&type=style&index=1&id=177a615a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177a615a",
  null
  
)

export default component.exports